const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '';
const ENDPOINT = `${API_BASE}/api/v1/technical-errors/report`;

// Session-level deduplication: same message+stack won't fire within 30 s
const seen = new Map<string, number>();

function dedupeKey(message: string, stack?: string): string {
  return `${message}::${(stack ?? '').slice(0, 200)}`;
}

function isDuplicate(key: string): boolean {
  const last = seen.get(key);
  if (last && Date.now() - last < 30_000) return true;
  seen.set(key, Date.now());
  return false;
}

export interface ErrorReport {
  errorType: 'Frontend' | 'Mobile' | 'Api';
  message: string;
  stackTrace?: string;
  componentStack?: string;
  url?: string;
  userId?: string;
  userEmail?: string;
  appVersion?: string;
  platform?: string;
  userAgent?: string;
  context?: string;
}

export function reportError(report: ErrorReport): void {
  const key = dedupeKey(report.message, report.stackTrace);
  if (isDuplicate(key)) return;

  const payload = JSON.stringify({
    ...report,
    url: report.url ?? window.location.href,
    platform: report.platform ?? 'Web',
    userAgent: report.userAgent ?? navigator.userAgent,
    appVersion: report.appVersion ?? import.meta.env.VITE_APP_VERSION,
  });

  // Prefer sendBeacon so errors on page unload still get through
  if (navigator.sendBeacon) {
    const blob = new Blob([payload], { type: 'application/json' });
    navigator.sendBeacon(ENDPOINT, blob);
  } else {
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  }
}
